// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"f3cffabf","236":"af887b86"}[chunkId] + ".chunk.css";
};